import { FC } from 'react';
import {
  Pagination as PaginationLib,
  PaginationItem,
  PaginationRenderItemParams,
} from '@mui/material';
import { useRouter } from 'next/router';
import cn from 'classnames';

import { PaginationThemeProvider } from './PaginationThemeProvider';
import ArrowBackIcon from '@/public/icons/arrow-back.svg';
import ArrowForwardIcon from '@/public/icons/arrow-forward.svg';
import { useMediaQueryWidthPicker } from '@/hooks';

interface PaginationProps {
  totalPages: number;
  currentPage: number;
  className?: string;
}

export const Pagination: FC<PaginationProps> = ({
  totalPages,
  currentPage = 1,
  className,
}) => {
  const router = useRouter();
  const path = router.asPath;
  const searchParams = new URLSearchParams(router.asPath.split('?')[1]);
  const { locale } = router;

  const { device } = useMediaQueryWidthPicker();
  const isMobile = device === 'mobile';

  const handlePageChange = (item: PaginationRenderItemParams) => {
    const pageValue = item.page !== null ? item.page.toString() : '';
    searchParams.set('page', pageValue);

    const newQuery = searchParams.toString();
    const href =
      locale === 'uk'
        ? `${path.split('?')[0]}?${newQuery}`
        : `/${locale}${path.split('?')[0]}?${newQuery}`;

    return (
      <PaginationItem
        component="a"
        className="dark:!text-white dark:hover:!text-darkGrayPM dark:focus:!text-darkGrayPM"
        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
        href={href}
        {...item}
      />
    );
  };

  return (
    <PaginationThemeProvider>
      <PaginationLib
        count={totalPages}
        page={currentPage}
        className={cn('flex justify-center', className)}
        variant="outlined"
        siblingCount={0}
        boundaryCount={1}
        size={isMobile ? 'medium' : 'large'}
        renderItem={item => handlePageChange(item)}
      />
    </PaginationThemeProvider>
  );
};
